<template>
    <v-container class="py-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Locais</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Home',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Locais',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                    <div class="button-group" style="padding-right: 16px;">
                        <!-- v-if="$check(user, ['passengers.create'])" -->
                        <v-btn v-if="$check(['locations.create'])" id="btnNew" type="button" color="primary"
                            elevation="0" to="/locais/novo">Incluir</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="filter-card">
                    <v-card-title class="filter-card-title">Filtros de busca</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="load()">
                            <v-row>
                                <v-col>
                                    <v-text-field dense id="osNumber" label="ID" v-model="dataList.filter.id"
                                        hide-details outlined></v-text-field>
                                </v-col>

                                <v-col>
                                    <v-text-field dense id="name" label="Nome" v-model="dataList.filter.name"
                                        hide-details outlined></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark
                                        elevation="2">Aplicar filtros</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-text>
                        <v-data-table :headers="dataList.headers" :items="dataList.data"
                            @update:items-per-page="pageSizeChanged" @update:page="pageChanged"
                            :server-items-length="dataList.count" :disable-sort="true" :loading="dataList.loading"
                            no-data-text="Nenhum local encontrado" loading-text="Carregando dados..."
                            class="app-table hover-table" :options.sync="dataList.options"
                            :footer-props="dataList.footerOptions">

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-row align="center">
                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-icon v-if="$check(['locations.update'])" v-on="on"
                                                @click="editItem(item)" size="large">
                                                mdi-pencil-outline
                                            </v-icon>
                                        </template>
                                        <span>Editar local</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-icon v-if="$check(['locations.delete'])" v-on="on"
                                                @click="deleteItem(item)" size="large">
                                                mdi-delete
                                            </v-icon>
                                        </template>
                                        <span>Remover local</span>
                                    </v-tooltip>
                                </v-row>
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-card>

                <v-divider></v-divider>
            </v-col>
        </v-row>

        <!-- MODAL DE EXCLUSÃO LOCAL -->
        <v-dialog v-model="deleteDialog" max-width="400px">
            <v-card>
                <v-card-title>
                    <v-icon large class="mr-2 error--text">mdi-alert-circle-outline</v-icon>
                    Aviso
                </v-card-title>
                <v-card-text class="pt-4 black--text">
                    Tem certeza que deseja excluir o local
                    <strong v-if="locationToDelete">{{ locationToDelete.name }}</strong>?
                    Esta ação não pode ser desfeita.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text @click="deleteDialog = false">
                        Cancelar
                    </v-btn>
                    <v-btn color="red darken-1" text @click="confirmDelete()">
                        Excluir
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

Vue.use(VueLodash)

export default {
    name: "LocationsList",

    data: () => ({
        dataset: {
            data: {}
        },
        dataList: {
            filter: {},
            headers: [
                { text: "ID", value: "id" },
                { text: "Nome", value: "name" },
                { text: 'Ações', value: 'actions', sortable: false },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                size: 10,
                sortBy: ['id'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            },
        },
        deleteDialog: false,
        locationToDelete: null,
    }),

    created() {
        this.load();
    },

    methods: {
        pageChanged(page) {
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {
            this.dataList.options.size = size;
            this.load(true);
        },

        async load() {
            this.dataList.loading = true;

            try {
                const result = await axios.get('api/v2/locations', { params: { page: this.dataList.options.page, limit: 10, search: { ...this.dataList.filter } } });

                console.log("Dados: ", result)

                this.dataList.data = result.data.content.data;

                this.dataList.count = result.data.content.total

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },

        editItem(item) {
            this.$router.push(`locais/${item.id}`);
        },

        deleteItem(item) {
            this.locationToDelete = item;
            this.deleteDialog = true;
        },

        async confirmDelete() {
            this.deleteDialog = false;
            this.dataList.loading = true;

            try {
                await axios.delete(`api/v2/locations/${this.locationToDelete.id}`);

                this.$dialog.notify.success('Local removido com sucesso!', { position: 'top-right', timeout: 3000 });
                await this.load();

            } catch (error) {
                console.error('Erro ao remover local:', error);
                this.$dialog.notify.error(`Erro ao remover local: ${this.$codes(error)}`, { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
                this.locationToDelete = null;
            }
        },

    },
};
</script>